import { WHY_TRAVEL } from "@/data/content";
import { Users, BookOpen, Map, Building2, TrainFront, Gift, ShieldCheck } from "lucide-react";

const ICONS = {
  users: Users,
  book: BookOpen,
  map: Map,
  building: Building2,
  train: TrainFront,
  gift: Gift,
  shield: ShieldCheck,
};

export default function WhyTravel() {
  return (
    <section data-testid="why-travel-section" className="py-20 md:py-28 bg-[var(--maqam-surface)]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <span className="overline">Why Maqam</span>
          <h2 className="font-serif text-4xl md:text-5xl text-navy mt-3 leading-[1.05] tracking-tight">
            Travel with knowledge. Travel with community.
          </h2>
          <p className="mt-5 text-[var(--maqam-muted)] leading-relaxed">
            Every detail of a Maqam journey — from accommodations to the educational
            program — is designed to elevate your worship and your experience.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_TRAVEL.map((w, i) => {
            const Icon = ICONS[w.icon] || ShieldCheck;
            return (
              <div
                key={i}
                data-testid={`why-card-${i}`}
                className="card-elevated rounded-xl p-7"
              >
                <span className="inline-flex w-11 h-11 rounded-full items-center justify-center" style={{background: 'rgba(212,175,55,0.14)'}}>
                  <Icon size={20} className="text-navy" />
                </span>
                <h3 className="mt-5 font-serif text-2xl text-navy tracking-tight">{w.title}</h3>
                <p className="mt-2 text-sm text-[var(--maqam-muted)] leading-relaxed">{w.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
